import { CHANGEABLE_PAGE_ITEM_PROPS } from './constants';

class DropableService {
  hasItemChanged(item, itemModified) {
    const isEqual = CHANGEABLE_PAGE_ITEM_PROPS.reduce((changed, prop) => {
      return changed && item[prop] === itemModified[prop];
    }, true);

    const hasChangedName = item.oldName;
    const hasPages = item.pages;
    const hasClassInfo = item.classesInfo;

    return !isEqual || hasChangedName || hasPages || hasClassInfo;
  }

  isItemsEqual(items, itemsModified) {
    if (items.length !== itemsModified.length) {
      return false;
    }

    for (let i = items.length; i--; ) {
      if (this.hasItemChanged(items[i], itemsModified[i])) {
        return false;
      }
    }

    return true;
  }

  isCheckedContentEqual(checkedContent, checkedContentModified) {
    return (
      checkedContent.nPublished === checkedContentModified.nPublished &&
      checkedContent.nUnpublished === checkedContentModified.nUnpublished &&
      checkedContent.nPublishedModules ===
        checkedContentModified.nPublishedModules
    );
  }

  isToogleModules(expandModule, expandModuleNext) {
    return expandModule !== expandModuleNext;
  }

  isModuleIdChanges(moduleId, moduleIdNext) {
    return moduleId !== moduleIdNext;
  }

  isPageIdChanges(pageId, pageIdNext) {
    return pageId !== pageIdNext;
  }
}

export default new DropableService();
